module.exports = __webpack_public_path__ + "img/agronomic_icon_black.7098aca7.svg";